import styled from 'styled-components';
import {media} from '../../styles/components/media-queries';
import {Wrapper} from '../../styles/pages/modal';
import {Button3a} from '../../styles/components/buttons';

export const PickerWrapper = styled(Wrapper)`
  width: 60rem;
  display: flex;
  flex-direction: column;
  ${media.smaller`
    width: 100%;
    max-height: 100vh;
    overflow: hidden;
  `};
`;

export const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  padding-bottom: 1rem;
  flex: 0 0 auto;
`;

export const Heading = styled.div`
  display: flex;
  flex-direction: column;
`;

export const Title = styled.div`
  font-weight: bold;
  text-transform: uppercase;
  font-size: 1.8rem;
`;

export const ProductName = styled.div`
  font-size: 1.6rem;
  margin-top: 0.5rem;
`;

export const PricePerKg = styled.div`
  font-size: 1.4rem;
  margin-top: 0.3rem;
`;

export const CloseButton = styled.button`
  background: transparent;
  border: 0;
  color: inherit;
  font-size: 2.4rem;
  line-height: 2.4rem;
  cursor: pointer;
  padding: 0 0.5rem;
`;

export const Body = styled.div`
  background-color: ${p => p.theme.tertiaryBgColor};
  color: ${p => p.theme.textColor};
  padding: 2rem;
  max-height: 60vh;
  overflow-y: auto;
  ${media.smaller`
    padding: 1rem;
    max-height: none;
    flex: 1 1 auto;
    min-height: 0;
  `};
`;

export const Intro = styled.p`
  margin: 0 0 1.5rem;
  font-size: 1.4rem;
  line-height: 2rem;
`;

export const Message = styled.p`
  margin: 0 0 1.5rem;
  font-size: 1.4rem;
  line-height: 2rem;
  color: ${p => (p.$isError ? p.theme.tertiaryAltColor : 'inherit')};
  font-weight: ${p => (p.$isError ? 'bold' : 'normal')};
`;

export const BoxList = styled.ul`
  list-style: none;
  margin: 0;
  padding: 0;
  max-height: 32rem;
  overflow-y: auto;
  ${media.smaller`
    max-height: none;
    overflow-y: visible;
  `};
`;

export const BoxRow = styled.li`
  border-bottom: 0.1rem solid ${p => p.theme.borderColor || '#ddd'};
  opacity: ${p => (p.$disabled ? 0.6 : 1)};
`;

export const BoxLabel = styled.label`
  display: grid;
  grid-template-columns: 3rem 1fr auto;
  align-items: center;
  gap: 1rem;
  padding: 1rem 0;
  cursor: ${p => (p.$disabled ? 'default' : 'pointer')};
  font-size: 1.4rem;
`;

export const BoxWeight = styled.span`
  font-weight: bold;
`;

export const BoxPrice = styled.span`
  text-align: right;
`;

export const BoxNumber = styled.span`
  display: block;
  font-size: 1.1rem;
  opacity: 0.7;
`;

// A sibling of Body, not a child of it, so it stays fixed at the bottom of
// the picker instead of scrolling away with a long box list.
export const Footer = styled.div`
  background-color: ${p => p.theme.tertiaryBgColor};
  color: ${p => p.theme.textColor};
  padding: 1.5rem 2rem 2rem;
  display: flex;
  flex-direction: column;
  gap: 1rem;
  flex: 0 0 auto;
  ${media.smaller`
    padding: 0 1rem 1rem;
  `};
`;

export const AddButton = styled(Button3a)`
  width: 100%;
  background-color: ${p =>
    p.$disabled ? 'transparent' : p.theme.secondaryColor};
  color: ${p =>
    p.$disabled ? p.theme.disabledColor : p.theme.primaryTextColor};
  pointer-events: ${p => (p.$disabled ? 'none' : 'auto')};
`;
